var _desc, _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWelcome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: 512,
    height: 512,
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "t"
  }, "Bienvenue") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "t"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "d"
  }, "Portail ouvert reprenant le motif crochet de la marque.")), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n  :root{\n    --line:#025D7D;\n    --accent:#30C5E5;\n  }\n  @media (prefers-color-scheme: dark){\n    :root{ --line:#7FD8EE; --accent:#30C5E5; }\n  }\n  .e   {fill:none;stroke:var(--line);stroke-width:2.6;stroke-linecap:round;stroke-linejoin:round}\n  .e2  {fill:none;stroke:var(--line);stroke-width:1.9;stroke-linecap:round;stroke-linejoin:round;opacity:.7}\n  .e3  {fill:none;stroke:var(--line);stroke-width:1.2;stroke-linecap:round;opacity:.34}\n  .h   {fill:none;stroke:var(--line);stroke-width:1.2;stroke-linecap:round;opacity:.22;stroke-dasharray:4 6}\n  .a   {fill:none;stroke:var(--accent);stroke-width:2.8;stroke-linecap:round;stroke-linejoin:round}\n  .a2  {fill:none;stroke:var(--accent);stroke-width:1.9;stroke-linecap:round;stroke-linejoin:round;opacity:.75}\n  .face {fill:var(--accent);opacity:.07;stroke:none}\n  .face2{fill:var(--accent);opacity:.16;stroke:none}\n  .faceL{fill:var(--line);opacity:.07;stroke:none}\n  .dot  {fill:var(--accent)}\n  .dotl {fill:var(--line);opacity:.45}\n  .txt  {fill:var(--line);font-family:Montserrat,'Helvetica Neue',Arial,sans-serif;font-weight:700}\n  .txta {fill:var(--accent);font-family:Montserrat,'Helvetica Neue',Arial,sans-serif;font-weight:700}\n  .halo {fill:var(--accent);opacity:.16;transform-box:fill-box;transform-origin:center;\n         animation:pulse 3.4s ease-in-out infinite}\n  .flow {stroke-dasharray:6 10;animation:flow 2.6s linear infinite}\n  .flow2{stroke-dasharray:4 8;animation:flow 3.4s linear infinite reverse}\n  .drift{transform-box:fill-box;transform-origin:center;\n         animation:drift 6s ease-in-out infinite}\n  #scene{animation:float 8s ease-in-out infinite}\n  @keyframes pulse{0%,100%{transform:scale(.62);opacity:.09}50%{transform:scale(1.32);opacity:.34}}\n  @keyframes flow {to{stroke-dashoffset:-32}}\n  @keyframes float{0%,100%{transform:translateY(0)}50%{transform:translateY(-7px)}}\n  @keyframes drift{0%,100%{transform:translate(0,0)}50%{transform:translate(0,-9px)}}\n  @media (prefers-reduced-motion: reduce){*{animation:none !important}}\n  .d0{animation-delay:0.0s}\n  .d1{animation-delay:0.1s}\n  .d2{animation-delay:0.2s}\n  .d3{animation-delay:0.3s}\n  .d4{animation-delay:0.4s}\n  .d5{animation-delay:0.5s}\n  .d6{animation-delay:0.6s}\n  .d7{animation-delay:0.7s}\n  .d8{animation-delay:0.8s}\n  .d9{animation-delay:0.9s}\n  .d10{animation-delay:1.0s}\n  .d11{animation-delay:1.1s}\n  .d12{animation-delay:1.2s}\n  .d13{animation-delay:1.3s}\n  .d14{animation-delay:1.4s}\n  .d15{animation-delay:1.5s}\n  .d16{animation-delay:1.6s}\n  .d17{animation-delay:1.7s}\n  .d18{animation-delay:1.8s}\n  .d19{animation-delay:1.9s}\n  .d20{animation-delay:2.0s}\n  .d21{animation-delay:2.1s}\n  .d22{animation-delay:2.2s}\n  .d23{animation-delay:2.3s}\n  .d24{animation-delay:2.4s}\n  .d25{animation-delay:2.5s}\n  .d26{animation-delay:2.6s}\n  .d27{animation-delay:2.7s}\n  .d28{animation-delay:2.8s}\n  .d29{animation-delay:2.9s}\n  .d30{animation-delay:3.0s}\n  .d31{animation-delay:3.1s}\n  .d32{animation-delay:3.2s}\n  .d33{animation-delay:3.3s}\n  .d34{animation-delay:3.4s}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "scene"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e3",
    d: "M 256 150 L 484.6 282 L 256 414 L 27.4 282 Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 238.9,
    y1: 186.3,
    x2: 90.2,
    y2: 272.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 269.3,
    y1: 203.9,
    x2: 120.7,
    y2: 289.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 299.8,
    y1: 221.5,
    x2: 151.2,
    y2: 307.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 330.3,
    y1: 239.1,
    x2: 181.7,
    y2: 324.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 360.8,
    y1: 256.7,
    x2: 212.2,
    y2: 342.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 391.3,
    y1: 274.3,
    x2: 242.7,
    y2: 360.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 421.8,
    y1: 291.9,
    x2: 273.1,
    y2: 377.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 238.9,
    y1: 186.3,
    x2: 421.8,
    y2: 291.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 209.1,
    y1: 203.5,
    x2: 392,
    y2: 309.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 179.4,
    y1: 220.6,
    x2: 362.3,
    y2: 326.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 149.7,
    y1: 237.8,
    x2: 332.6,
    y2: 343.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 120,
    y1: 254.9,
    x2: 302.9,
    y2: 360.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 90.2,
    y1: 272.1,
    x2: 273.1,
    y2: 377.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "face2",
    d: "M 216 130.2 L 187.4 146.7 L 187.4 258.9 L 216 242.4 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "faceL",
    d: "M 167.4 135.1 L 187.4 146.7 L 187.4 258.9 L 167.4 247.3 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "face",
    d: "M 196 118.6 L 216 130.2 L 187.4 146.7 L 167.4 135.1 Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    x1: 196,
    y1: 230.8,
    x2: 196,
    y2: 118.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    x1: 196,
    y1: 230.8,
    x2: 216,
    y2: 242.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    x1: 196,
    y1: 230.8,
    x2: 167.4,
    y2: 247.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M 196 118.6 L 216 130.2 L 187.4 146.7 L 167.4 135.1 Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 216,
    y1: 130.2,
    x2: 216,
    y2: 242.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 187.4,
    y1: 146.7,
    x2: 187.4,
    y2: 258.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 167.4,
    y1: 135.1,
    x2: 167.4,
    y2: 247.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 216,
    y1: 242.4,
    x2: 187.4,
    y2: 258.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 187.4,
    y1: 258.9,
    x2: 167.4,
    y2: 247.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "face2",
    d: "M 344.6 204.4 L 316 220.9 L 316 333.1 L 344.6 316.6 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "faceL",
    d: "M 296 209.4 L 316 220.9 L 316 333.1 L 296 321.6 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "face",
    d: "M 324.6 192.9 L 344.6 204.4 L 316 220.9 L 296 209.4 Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    x1: 324.6,
    y1: 305.1,
    x2: 324.6,
    y2: 192.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    x1: 324.6,
    y1: 305.1,
    x2: 344.6,
    y2: 316.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    x1: 324.6,
    y1: 305.1,
    x2: 296,
    y2: 321.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M 324.6 192.9 L 344.6 204.4 L 316 220.9 L 296 209.4 Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 344.6,
    y1: 204.4,
    x2: 344.6,
    y2: 316.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 316,
    y1: 220.9,
    x2: 316,
    y2: 333.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 296,
    y1: 209.4,
    x2: 296,
    y2: 321.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 344.6,
    y1: 316.6,
    x2: 316,
    y2: 333.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 316,
    y1: 333.1,
    x2: 296,
    y2: 321.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 201.7,
    y1: 138.4,
    x2: 310.3,
    y2: 201.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "face2",
    d: "M 210.3 245 L 318.9 307.7 L 301.7 317.6 L 193.1 254.9 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a2 flow",
    d: "M 210.3 245 L 318.9 307.7 L 301.7 317.6 L 193.1 254.9 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e3",
    d: "M 208.5 248 L 303.5 302.8 L 303.5 208 L 208.5 153.1 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e3",
    d: "M 214.5 248.5 L 297.5 296.5 L 297.5 208.1 L 214.5 160.2 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e3",
    d: "M 220.4 249.1 L 291.6 290.1 L 291.6 208.3 L 220.4 167.3 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e3",
    d: "M 226.4 249.6 L 285.6 283.8 L 285.6 208.5 L 226.4 174.3 Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "halo d0",
    cx: 256,
    cy: 222.6,
    r: 9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dot",
    cx: 256,
    cy: 222.6,
    r: 4.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "halo d5",
    cx: 191.7,
    cy: 132.7,
    r: 9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dot",
    cx: 191.7,
    cy: 132.7,
    r: 3.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "halo d10",
    cx: 320.3,
    cy: 206.9,
    r: 9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dot",
    cx: 320.3,
    cy: 206.9,
    r: 3.2
  })), /*#__PURE__*/React.createElement("circle", {
    className: "dot drift d0",
    cx: 118,
    cy: 128,
    r: 3.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dotl drift d11",
    cx: 398,
    cy: 150,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dot drift d20",
    cx: 424,
    cy: 322,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dotl drift d6",
    cx: 92,
    cy: 306,
    r: 2.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dot drift d26",
    cx: 352,
    cy: 96,
    r: 2.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dotl drift d13",
    cx: 128,
    cy: 402,
    r: 2.8
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWelcome);
export default __webpack_public_path__ + "static/media/welcome.5b6df510ed743dc6830f22bb7e9d155c.svg";
export { ForwardRef as ReactComponent };